module.exports = __webpack_public_path__ + "h5/img/promoter.af8f88db.png";